import { createContext, useContext } from 'react';
import { FEATURE_FLAGS } from '@Constants/featureFlagConstants';

export type FeatureFlags = typeof FEATURE_FLAGS;

export interface IFeatureFlagsContext {
    featureFlags: FeatureFlags;
    isFeatureEnabled: (featureName: keyof FeatureFlags) => boolean;
}

export const FeatureFlagsContext = createContext<IFeatureFlagsContext>({
    featureFlags: FEATURE_FLAGS,
    isFeatureEnabled: () => false,
});

export function useFeatureFlags(): IFeatureFlagsContext {
    const featureFlagsContext = useContext(FeatureFlagsContext);
    return featureFlagsContext;
}
